import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/Primitives";
import { BookingsTable } from "@/components/BookingsTable";
import { FilterBar, filterParams } from "@/components/FilterBar";
import { Button } from "@/components/ui/button";

export default function Bookings() {
  const { user } = useAuth();
  const [f, setF] = useState({ preset: "all" });
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/bookings", { params: filterParams(f) }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [f]);

  return (
    <div data-testid="bookings-page">
      <PageHeader eyebrow={user.role === "agent" ? "My pipeline" : "Agency-wide"} title={user.role === "agent" ? "My Bookings" : "All Bookings"}>
        {user.role === "agent" && <Button asChild className="bg-indigo-600 hover:bg-indigo-500"><Link to="/bookings/new" data-testid="new-booking-btn"><PlusCircle className="h-4 w-4 mr-2" />New Booking</Link></Button>}
      </PageHeader>
      <FilterBar value={f} onChange={setF} showAgents={user.role !== "agent"} showStatus showSearch />
      {rows === null ? <div className="text-slate-500">Loading…</div> : <BookingsTable rows={rows} showAgent={user.role !== "agent"} />}
      {rows && <div className="text-xs text-slate-600 mt-2" data-testid="bookings-count">{rows.length} record(s)</div>}
    </div>
  );
}
